//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { IPromotedPostsTargetState } from '../models/AppState';
import {
    PROMOTED_POSTS_TARGET_ACTIONS,
    PromotedPostsTargetCTAs,
    PromotedPostsTargetOptions,
} from '../promoted-posts-constants/promoted-posts-target-constants';

const initialState: IPromotedPostsTargetState = {
  isFetchingProductCount: false,
  productCount: null,
  isFetchingShowroomForPost: false,
  showroomExistsForPost: false,
  showroomLink: null,
  showroomPreviewLink: null,
  selectedTarget: PromotedPostsTargetOptions.SHOWROOM_LINK,
  targetIsShowroom: true,
  customLink: null,
  targetLink: null,
  targetLinkCTA: PromotedPostsTargetCTAs.SHOP_NOW,
};

export default function PromotedPostsTargetReducer(state = initialState, action) {
  switch (action.type) {
    case PROMOTED_POSTS_TARGET_ACTIONS.CLEAR_PROMOTED_POSTS_TARGET_STATE:
      return initialState;
    case PROMOTED_POSTS_TARGET_ACTIONS.REQUEST_PRODUCT_COUNT:
      return {
        ...state,
        isFetchingProductCount: true,
      };
    case PROMOTED_POSTS_TARGET_ACTIONS.RECEIVE_PRODUCT_COUNT:
      return {
        ...state,
        productCount: action.paylaod,
        isFetchingProductCount: false,
      };
    case PROMOTED_POSTS_TARGET_ACTIONS.REQUEST_SHOWROOM_FOR_POST:
      return {
        ...state,
        isFetchingShowroomForPost: true,
      };
    case PROMOTED_POSTS_TARGET_ACTIONS.RECEIVE_SHOWROOM_FOR_POST:
      return {
        ...state,
        showroomExistsForPost: action.payload.showroomExistsForPost,
        showroomLink: action.payload.showroomData.shortLink,
        showroomPreviewLink: action.payload.showroomData.previewUrl,
        isFetchingShowroomForPost: false,
      };
    case PROMOTED_POSTS_TARGET_ACTIONS.UPDATE_SELECTED_TARGET:
      return {
        ...state,
        selectedTarget: action.payload.selectedTarget,
        targetIsShowroom: action.payload.targetIsShowroom,
      };
    case PROMOTED_POSTS_TARGET_ACTIONS.UPDATE_TARGET_LINK:
      return {
        ...state,
        targetLink: action.payload,
      };
    case PROMOTED_POSTS_TARGET_ACTIONS.UPDATE_CUSTOM_LINK:
      return {
        ...state,
        customLink: action.payload,
      };
    case PROMOTED_POSTS_TARGET_ACTIONS.UPDATE_TARGET_LINK_CTA:
      return {
        ...state,
        targetLinkCTA: action.payload,
      };
    default:
      return state;
  }
}
